import StationElevationPlot, {StaElevPlotLayer} from "../outputs/ui/StationElevationPlot";
import React from "react";

export default function CrossSectionPlot({item}) {
    return (
        <>
            <StationElevationPlot
                height={(window.innerHeight / 2) - 15}
                width={1000}
                layers={
                    [
                        StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                        StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV_BURN_OUT,
                        StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV_MODIFIED,
                        StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                        StaElevPlotLayer.StaElevLayerNames.B_THALWEG,
                    ]
                }
                locWselEnable={false}
                globalVariables={{}}
                plotTitle={`${item?.cross_section} US (${item?.str_id})`}
                plotData={{
                    base: item?.plot_base
                }}
            />
        </>
    )
}